import React, { useEffect, useState } from "react";
import { Button, Empty, message, Popconfirm, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import {
  ArrowRightOutlined,
  LoadingOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import CompanyServices from "../../services/CompanyServices";
import { translate } from "../../locale";
import ProtocolServices from "../../services/ProtocolServices";
import { TableHelper } from "../../helpers/TableHelper";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const ProtocolAssociatedCoTable = ({ reload, protocol }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 25,
      total: 0,
    },
  });
  const [total, setTotal] = useState(0);

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (text, record, index) => (
        <div className="flex space-x-2">
          <Button
            type="text"
            icon={<ArrowRightOutlined />}
            size="small"
            className="border-0"
            onClick={() => navigate(`/admin/companies/${record.id}`)}
          />
          <Popconfirm
            title={
              <>
                {translate(
                  "¿Está seguro de que quiere desvincular esta empresa del protocolo?"
                )}
                <br />
                {translate("Esta acción no se puede deshacer")}
              </>
            }
            okText="Si"
            cancelText="No"
            onConfirm={() => handleDelete(record)}
          >
            <Tooltip title="Eliminar" color="blur">
              <Button
                type="text"
                icon={<DeleteOutlined />}
                size="small"
                className="border-0"
              />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
    },
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: translate("Nombre"),
      dataIndex: "name",
      key: "name",
      render: (_, record) => (
        <a
          onClick={() => navigate(`/admin/companies/${record.id}`)}
          className="text-black hover:text-custom_primary"
        >
          {record.name}
        </a>
      ),
      sorter: { multiple: 1 },
    },
    /* {
      title: translate("¿Asociada al protocolo?"),
      dataIndex: "associated",
      key: "associated",
      render: (_, record) =>
        record.associated === "yes" ? translate("Si") : translate("No"),
      filters: [
        {
          text: translate("Si"),
          value: "yes",
        },
        {
          text: translate("No"),
          value: "no",
        },
      ],
      onFilter: (value, record) => record.associated === value,
    }, */
  ];

  useEffect(() => {
    if (reload !== null && protocol?.id) {
      loadCompanies();
    }
  }, [reload, protocol, JSON.stringify(tableParams)]);

  const loadCompanies = async () => {
    let data = {
      page_size: tableParams.pagination.pageSize,
      page_num: tableParams.pagination.current,
    };
    const sorter = TableHelper.sorter(tableParams);
    if (sorter !== null) {
      data = { ...data, order_by: sorter };
    }
    setLoading(true);
    try {
      const res = await CompanyServices.getProtocolCompanies(protocol.id);
      if (
        res.status >= 200 &&
        res.status < 300 &&
        res.data.enterprises.length > 0
      ) {
        setData(res.data.enterprises);
        setTotal(res.data.total_pages * tableParams.pagination.pageSize);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleDelete = async (enterprise) => {
    setLoading(true);
    try {
      const res = await ProtocolServices.updateProtocol({
        protocol_id: protocol.id,
        enterprises_delete: [enterprise.id],
      });
      if (res.status >= 200 && res.status < 300) {
        message.success(
          translate("La {0} se elimino exitosamente.", translate("empresa"))
        );
      } else {
        message.error(res.data.message);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey={(i) => i.id}
      loading={
        loading ? { indicator: antIcon, className: "text-custom_blue" } : false
      }
      locale={{
        emptyText: <Empty description={translate("No hay datos")} />,
        sortTitle: translate("Ordenar"),
        triggerDesc: translate("Ordenar (descendente)"),
        triggerAsc: translate("Ordenar (ascendente)"),
        cancelSort: translate("Cancelar orden"),
      }}
      pagination={{ ...tableParams.pagination, total: total }}
      onChange={handleTableChange}
    />
  );
};

export default ProtocolAssociatedCoTable;
